import { LetterheadConfig } from '../data/defaultLetterhead';
import { TypographyStyle } from '../data/typographyTemplates';

export interface DocumentState {
  content: string;
  letterheadConfig: LetterheadConfig;
  typographyStyle: TypographyStyle;
  lastSaved: string | null;
}

const STORAGE_KEY = 'qwickdocs_draft';

export const useDocumentStorage = () => {
  const loadDraft = (): DocumentState | null => {
    try {
      const saved = localStorage.getItem(STORAGE_KEY);
      if (!saved) return null;

      const parsed = JSON.parse(saved);
      return parsed;
    } catch (error) {
      console.error('Error loading draft:', error);
      // Clear corrupted draft
      localStorage.removeItem(STORAGE_KEY);
      return null;
    }
  };

  const saveDraft = (state: Omit<DocumentState, 'lastSaved'>): void => {
    try {
      const dataToSave: DocumentState = {
        ...state,
        lastSaved: new Date().toISOString(),
      };
      localStorage.setItem(STORAGE_KEY, JSON.stringify(dataToSave));
    } catch (error) {
      // Handle quota exceeded error
      if (error instanceof DOMException && error.name === 'QuotaExceededError') {
        console.error('LocalStorage quota exceeded. Document too large.');
        // In a real app, you might show a user-facing error here
      } else {
        console.error('Error saving draft:', error);
      }
      throw error;
    }
  };

  const clearDraft = (): void => {
    localStorage.removeItem(STORAGE_KEY);
  };

  return { loadDraft, saveDraft, clearDraft };
};
